/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Reinforced Crate tint for a virtual LootBox — primary glow (g1) + metal trim (g2), hex colors.
 * @export
 * @interface CrateColor
 */
export interface CrateColor {
    /**
     * 
     * @type {string}
     * @memberof CrateColor
     */
    g1: string;
    /**
     * 
     * @type {string}
     * @memberof CrateColor
     */
    g2: string;
}

/**
 * Check if a given object implements the CrateColor interface.
 */
export function instanceOfCrateColor(value: object): value is CrateColor {
    if (!('g1' in value) || value['g1'] === undefined) return false;
    if (!('g2' in value) || value['g2'] === undefined) return false;
    return true;
}

export function CrateColorFromJSON(json: any): CrateColor {
    return CrateColorFromJSONTyped(json, false);
}

export function CrateColorFromJSONTyped(json: any, ignoreDiscriminator: boolean): CrateColor {
    if (json == null) {
        return json;
    }
    return {
        
        'g1': json['g1'],
        'g2': json['g2'],
    };
}

export function CrateColorToJSON(json: any): CrateColor {
    return CrateColorToJSONTyped(json, false);
}

export function CrateColorToJSONTyped(value?: CrateColor | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'g1': value['g1'],
        'g2': value['g2'],
    };
}

